var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", [
    _vm.settings.work.queue
      ? _c(
          "div",
          { staticClass: "column-left" },
          [
            _c(
              "draggable",
              {
                attrs: { group: "planned-cards" },
                on: {
                  start: function($event) {
                    _vm.drag = true
                  },
                  end: function($event) {
                    _vm.drag = false
                  },
                  change: _vm.checkMove
                },
                model: {
                  value: _vm.plannedList,
                  callback: function($$v) {
                    _vm.plannedList = $$v
                  },
                  expression: "plannedList"
                }
              },
              [
                _c(
                  "transition-group",
                  { attrs: { name: "list", appear: "" } },
                  _vm._l(_vm.plannedList, function(card, index) {
                    return _c("div", { key: card.id }, [
                      _c(
                        "a",
                        { attrs: { href: card.link, target: "_blank" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card",
                              class: [
                                {
                                  neutral:
                                    _vm.defaultZero(card.planned_days) <
                                      _vm.oldThreshold &&
                                    _vm.defaultZero(card.planned_days) >
                                      _vm.newThreshold
                                },
                                {
                                  new:
                                    _vm.defaultZero(card.planned_days) <=
                                    _vm.newThreshold
                                },
                                {
                                  old:
                                    _vm.defaultZero(card.planned_days) >=
                                    _vm.oldThreshold
                                }
                              ]
                            },
                            [
                              _c("h5", [
                                _vm._v(_vm._s(card.contract)),
                                _c("span", { staticClass: "timestamp" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatTimestamp(
                                        card.planned_first_seen,
                                        "month"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(card.name))]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "priority" }, [
                                    index > 0
                                      ? _c(
                                          "div",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.toTop(card.id)
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "arrows",
                                              attrs: {
                                                src: require("../../assets/arrow_up-24px.svg")
                                              }
                                            })
                                          ]
                                        )
                                      : _c("div", [
                                          _c("img", {
                                            staticClass: "arrows-inactive",
                                            attrs: {
                                              src: require("../../assets/arrow_up-24px.svg")
                                            }
                                          })
                                        ]),
                                    _vm._v(" "),
                                    index < _vm.plannedList.length - 1
                                      ? _c(
                                          "div",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.toBottom(card.id)
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "arrows",
                                              attrs: {
                                                src: require("../../assets/arrow_down-24px.svg")
                                              }
                                            })
                                          ]
                                        )
                                      : _c("div", [
                                          _c("img", {
                                            staticClass: "arrows-inactive",
                                            attrs: {
                                              src: require("../../assets/arrow_down-24px.svg")
                                            }
                                          })
                                        ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.settings.global.dots
                                ? _c(
                                    "div",
                                    { staticClass: "days" },
                                    _vm._l(
                                      _vm.dots(
                                        _vm.defaultZero(card.planned_days)
                                      ),
                                      function(n, i) {
                                        return _c("div", { key: i }, [
                                          _c("div", {
                                            domProps: { innerHTML: _vm._s(n) }
                                          })
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _c("div", { staticClass: "days" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.defaultZero(card.planned_days)
                                        ) +
                                        "\n            "
                                    )
                                  ])
                            ]
                          )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76ec5ec0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ec5ec0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Work/PriorityList.vue
// module id = null
// module chunks = 